import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiChevronUp, FiChevronDown } from 'react-icons/fi';
import './PurchaseOrderList.scss';

function SortButton({ field, label, sortBy, onSort }) {
  const isActive = sortBy.field === field;
  const isAsc = sortBy.direction === 'asc';
  const Icon = isActive ? (isAsc ? FiChevronUp : FiChevronDown) : FiChevronUp;

  return (
    <button
      type="button"
      className={`sort-button ${isActive ? 'active' : ''}`}
      onClick={(e) => {
        e.stopPropagation();
        onSort(field);
      }}
      aria-label={`Sort by ${label} ${
        isActive ? (isAsc ? 'descending' : 'ascending') : 'ascending'
      }`}
    >
      <span className="sort-label">{label}</span>
      <span className="sort-icon">
        <Icon />
      </span>
    </button>
  );
}

function OrderDataRow({
  purchaseOrder: {
    id,
    clientStatus,
    clientPurchaseOrderNumber,
    vendor: { companyName }
  }
}) {
  const navigate = useNavigate();

  return (
    <div
      className="order-data-row"
      onClick={() => {
        if (clientStatus === 'receiving')
          navigate({
            pathname: `/unserialized-receiving/${id}`
          });
        if (clientStatus === 'received')
          navigate({
            pathname: `/unserialized-stocking/${id}`
          });
      }}
    >
      <div className="order-row-data">{clientPurchaseOrderNumber}</div>
      <div>
        <span>{companyName}</span>
      </div>
    </div>
  );
}

function PurchaseOrderList({ purchaseOrders, selectedStatus, sortBy, onSort }) {
  return (
    <div className="purchase-order-list">
      {selectedStatus === 'received' && (
        <div className="section-title">partially stocked</div>
      )}
      <div className="section-title">
        ready to {selectedStatus === 'receiving' ? 'receive' : 'stock'}
      </div>
      <div className="order-header-row">
        <SortButton field="number" label="Order #" sortBy={sortBy} onSort={onSort} />
        <SortButton field="vendor" label="Vendor" sortBy={sortBy} onSort={onSort} />
      </div>
      {purchaseOrders.map((purchaseOrder) => (
        <OrderDataRow key={purchaseOrder.id} purchaseOrder={purchaseOrder} />
      ))}
    </div>
  );
}

export default PurchaseOrderList;
